import { RealEstateActionHouseRemoveBold } from '@ha/icons';
import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Link } from 'ha/ui.legacy/Link';
import { SmartTrack as Track } from 'ha/components/track/SmartTrack';
import { Box, Button, Typography, Grid } from '@hbf/dsl';
import { useIntl } from 'ha/i18n';
import { searchParamsToObject } from 'ha/utils/routes/searchParamsToObject';

interface Props {
  cityLocalised: string;
  countryLocalised: string;
}

const ListingUnavailableCard: React.FC<Props> = ({
  cityLocalised,
  countryLocalised,
}) => {
  const { T, urlResolver } = useIntl();
  const [searchParams] = useSearchParams();

  return (
    <Grid
      container
      spacing={1}
      justifyContent="center"
      data-test-locator="ListingUnavailableCard"
    >
      <Grid item xs={12}>
        <Typography.H1Light align="center">
          <RealEstateActionHouseRemoveBold fontSize="large" color="inherit" />
        </Typography.H1Light>
      </Grid>
      <Grid item xs={12}>
        <Typography.H3
          align="center"
          data-test-locator="Looks like this place is not available anymore."
        >
          {T('Looks like this place is not available anymore.')}
        </Typography.H3>
        <Typography.Paragraph align="center">
          {T(
            'But relax! There are a lot of other accommodations ready for you to book.',
          )}
        </Typography.Paragraph>
      </Grid>
      <Box mt={2}>
        <Grid item>
          <Track name="Clicked Show me more accommodations" type="link">
            <Link
              to={
                cityLocalised && countryLocalised
                  ? urlResolver.getSearchUrl(
                      cityLocalised,
                      countryLocalised,
                      searchParamsToObject(searchParams),
                    )
                  : urlResolver.getBaseUrl()
              }
              skipLangFormat
              data-test-locator="ListingUnavailableCard - Link"
            >
              <Button variant="contained" color="primary" size="large">
                {T('Show me more accommodations!')}
              </Button>
            </Link>
          </Track>
        </Grid>
      </Box>
    </Grid>
  );
};

export { ListingUnavailableCard };
